const translationPath =
  "page.4uSalesContract.registers.beneficiaryTerminationReasons.";

export const buildTPath = (path: string) => translationPath + path;
